import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'ff-accordion-row-body',
  templateUrl: './accordion-row-body.component.html',
  styleUrls: ['./accordion-row-body.component.scss']
})
export class AccordionRowBodyComponent implements OnInit {
  
  @ViewChild('template') template: TemplateRef<any>;

  constructor() { }

  ngOnInit(): void {
  }

}
